import React from 'react';
import TaskActionIcon, { TaskActionIconType } from 'models/onboarding/process/action/TaskActionIcon';
import images from 'assets/images';
import SVGImage from 'components/commons/SVGImage';

export type ActionIconImageProps = { icon?: TaskActionIcon | string | null };

export const ActionIconImage = ({ icon }: ActionIconImageProps) => {
	if (!icon) {
		return null;
	}

	if (typeof icon === 'string') {
		return <SVGImage className="action__icon" src={icon} />;
	}

	if (icon.type === TaskActionIconType.STATIC) {
		return (
			<SVGImage
				className="action__icon"
				src={images.portal.sectionIcons[icon.value as keyof typeof images.portal.sectionIcons]}
			/>
		);
	}

	return <SVGImage className="action__icon" src={icon.value} />;
};
